import { CalendarPreview } from './CalendarPreview';
import { LocationForm } from './LocationForm';
import { CalendarLocationSectionProps } from '../../types';

export function CalendarLocationSection({
  title,
  imageUrl,
  location,
  altText,
  showRemove = false,
  style,
  fields,
  withBorder = true,
  onFieldChange,
  onRemove,
}: CalendarLocationSectionProps) {
  return (
    <div className={`bg-white rounded-xl ${withBorder ? 'p-6 shadow-lg border border-gray-200' : ''}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
        {showRemove && onRemove && (
          <button
            onClick={onRemove}
            className="text-gray-400 hover:text-gray-600 text-sm font-medium"
          >
            Remove
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Left column: controls + form */}
        <div className="space-y-4">
          <div>
            <LocationForm location={location} onFieldChange={onFieldChange} fields={fields} />
          </div>
        </div>

        {/* Right column: preview */}
        <div>
          <h4 className="text-sm font-medium text-gray-700 mb-3">Print Preview</h4>
          <CalendarPreview
            imageUrl={imageUrl}
            location={location}
            altText={altText}
            style={style}
            fields={fields}
          />
        </div>
      </div>
    </div>
  );
}
